var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmokeDetector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property Detail - Pricng detail closed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3741,
    transform: "translate(-119 -1788)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.78 10.798C12.78 10.2767 12.5771 9.78661 12.2085 9.41801C12.0027 9.21223 11.6691 9.21223 11.4633 9.41801C11.2575 9.62379 11.2575 9.95741 11.4633 10.1632C11.6328 10.3328 11.7262 10.5582 11.7262 10.798C11.7262 11.0378 11.6328 11.2632 11.4633 11.4327C10.7023 12.1937 10.7023 13.4318 11.4633 14.1927C11.5662 14.2956 11.701 14.347 11.8358 14.347C11.9707 14.347 12.1056 14.2956 12.2084 14.1927C12.4142 13.9869 12.4142 13.6533 12.2084 13.4475C11.8584 13.0975 11.8584 12.5279 12.2084 12.1779C12.5771 11.8093 12.78 11.3193 12.78 10.798Z",
    fill: "#01152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.96948 10.798C9.96948 10.2767 9.76651 9.78661 9.3979 9.41801C9.19216 9.21223 8.85851 9.21223 8.65272 9.41801C8.44694 9.62379 8.44694 9.95741 8.65272 10.1632C8.82225 10.3328 8.91562 10.5582 8.91562 10.798C8.91562 11.0378 8.82229 11.2632 8.65272 11.4327C7.8918 12.1937 7.8918 13.4318 8.65272 14.1927C8.75561 14.2956 8.89047 14.347 9.0253 14.347C9.16015 14.347 9.29501 14.2956 9.39787 14.1927C9.60365 13.9869 9.60365 13.6533 9.39787 13.4475C9.04785 13.0975 9.04785 12.5279 9.39787 12.1779C9.76651 11.8093 9.96948 11.3193 9.96948 10.798Z",
    fill: "#01152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.53555 9.41801C6.32983 9.21223 5.99618 9.21223 5.79036 9.41801C5.58461 9.62379 5.58458 9.95741 5.79036 10.1632C6.14035 10.5132 6.14035 11.0828 5.79036 11.4327C5.42176 11.8013 5.21875 12.2914 5.21875 12.8127C5.21875 13.334 5.42176 13.8241 5.79036 14.1927C5.89325 14.2956 6.02811 14.347 6.16294 14.347C6.2978 14.347 6.43265 14.2956 6.53551 14.1927C6.74129 13.9869 6.74126 13.6533 6.53551 13.4475C6.36594 13.2779 6.27257 13.0525 6.27257 12.8127C6.27257 12.5729 6.36594 12.3475 6.53551 12.178C7.29647 11.417 7.29647 10.1789 6.53555 9.41801Z",
    fill: "#01152E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.473 0H0.526929C0.235924 0 0 0.235924 0 0.526929V2.72528C0 3.01628 0.235924 3.25221 0.526929 3.25221H1.4996L2.15721 5.72621C2.15728 5.72642 2.15735 5.72659 2.15739 5.7268C2.15742 5.72694 2.15746 5.72709 2.15749 5.72726L2.71955 7.82472C2.78131 8.05506 2.99004 8.21524 3.22853 8.21524H14.7714C15.0099 8.21524 15.2187 8.05506 15.2804 7.82472L15.8425 5.72726C15.8425 5.72712 15.8425 5.72698 15.8426 5.7268C15.8426 5.72659 15.8427 5.72642 15.8428 5.72621L16.5004 3.25221H17.4731C17.7641 3.25221 18 3.01628 18 2.72528V0.526929C18 0.235924 17.7641 0 17.473 0ZM3.07164 5.06393L2.5901 3.25221H4.60891V5.06393H3.07164ZM9.52691 5.06393V3.25221H12.3372V5.06393H9.52691ZM8.47305 5.06393H5.66277V3.25221H8.47305V5.06393ZM14.3671 7.16139H3.63286L3.3532 6.11779H14.6468L14.3671 7.16139ZM14.9283 5.06393H13.3911V3.25221H15.4099L14.9283 5.06393ZM16.9461 2.19835H1.05386V1.05386H16.9461V2.19835Z",
    fill: "#01152E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmokeDetector);
export default __webpack_public_path__ + "static/media/smoke-detector.ccfd5429f09df0600ef42d383526397d.svg";
export { ForwardRef as ReactComponent };